import cn from 'classnames';
import { isSameDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useTranslation } from 'react-i18next';
import type { CalendarMode } from '../types';
import styles from './header.module.css';
import { TimezonesWithTooltip } from './timezones-with-tooltip';

type Properties = {
  days: Date[];
  mode: CalendarMode;
  orderedTimezones: string[];
  primaryTimezone: string;
  scrollbarWidth: number;
};

const Header = ({ days, mode, orderedTimezones, primaryTimezone, scrollbarWidth }: Properties) => {
  const { t } = useTranslation(['translationReactComponents']);

  return (
    <div className={styles.header} style={{ paddingRight: `${scrollbarWidth}px` }}>
      <TimezonesWithTooltip orderedTimezones={orderedTimezones} />
      <div
        className={cn(styles.title, {
          [styles['title-day'] ?? '']: mode === 'day',
          [styles['title-week'] ?? '']: mode === 'week',
          [styles['week-grid'] ?? '']: mode === 'week',
        })}
      >
        {days.map((day) => (
          <div
            className={cn(styles['title-week-inner'], {
              [styles['current-day'] ?? '']: isSameDay(day, toZonedTime(new Date(), primaryTimezone)),
            })}
            key={day.toISOString()}
          >
            {t('dateFormats.dayNumberShortDay', { date: day })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Header;
